export default "__VITE_ASSET__BWvAUsxv__"